import React, { useEffect, useState } from "react";
import axios from "axios";
import { IMG_BASE_URL, StudentProfile } from "../../../AllAPI/StudentAPI";

const PaymentDetails = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

   const formDataFromStorage = JSON.parse(
    sessionStorage.getItem('studentData') || '{}',
  )
  const RegId = formDataFromStorage.reg_id;
  const BoardingYear = formDataFromStorage.year;

  // Format date ⇒ dd/mm/yyyy
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const d = new Date(dateString);
    return d.toLocaleDateString("en-GB"); // dd/mm/yyyy
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const res = await axios.get(`${StudentProfile}/${RegId}/${BoardingYear}`);
      setData(res.data);
    } catch (err) {
      console.log("Error:", err);
    }
    setLoading(false);
  };

  if (loading) return <h4 className="text-center mt-5">Loading...</h4>;
  if (!data) return <h4 className="text-center mt-5">No Profile Found</h4>;

  const payment = data.payment || {};


  const renderFile = (fileName) => {
  if (!fileName) return <p className="text-muted">No File</p>;

  const fileUrl = `${IMG_BASE_URL}/${fileName}`;

  if (fileName.toLowerCase().endsWith(".pdf")) {
    return (
      <>
        <iframe
          src={fileUrl}
          title="PDF"
          width="100%"
          height="300px"
          style={{ border: "1px solid #ccc", borderRadius: "6px" }}
        />
        <a
          href={fileUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-sm btn-primary mt-2"
        >
          Download PDF
        </a>
      </>
    );
  }

  return (
    <img
      src={fileUrl}
      alt="Payment"
      style={{
        width: "100%",
        objectFit: "contain",
        display: "block",
      }}
    />
  );
};


  return (
    <div className="form-container mainContainer ">

    
     <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">

          <div className="header-row">
            <h2 className="page-title">Payment Details</h2>
          </div>

      {/* ========================= PAYMENT DETAILS ============================= */}
      <div className="card shadow-sm p-4 mb-4">

        <div className="row">
          <div className="col-md-6 mb-3 p-1 px-2">
              <div className="shadow rounded p-2 px-3" style={{backgroundColor:"#fddcecff"}}>
            <span style={{fontWeight:"600"}}>Registration Payment:</span>
            <p className="pt-2">Pay Date: {formatDate(payment.register_pay_date)}</p>
            <p>Tax Id: {payment.register_tax_id}</p>
            <p>Amount: {payment.register_pay_amount}</p>
            <p>Uploaded Image:<br />
                <div
                  style={{
                    width: "100%",
                    height: "auto",
                    // height: "180px",
                    overflow: "hidden",
                    borderRadius: "8px",
                  }}
                >
                  {/* <img
                    src={`${IMG_BASE_URL}/${payment.register_tax_image}`}
                    alt="Payment Img"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      display: "block"
                    }}
                  /> */}

                  {renderFile(payment.register_tax_image)}
                </div>
              </p>

              </div>
          </div>

          <div className="col-md-6 mb-3 p-1 px-2">
              <div className="shadow rounded p-2 px-3" style={{backgroundColor:"#cff3f9ff"}}>
                <span style={{fontWeight:"600"}}>Hostel Payment:</span>
                <p className="pt-2">Pay Date: {formatDate(payment.hostel_pay_date)}</p>
                <p>Tax Id: {payment.hostel_tax_id}</p>
                <p>Amount: {payment.hostel_pay_amount}</p>
                <p> Uploaded Image : <br />
                <div
                  style={{
                    width: "100%",
                    height: "auto",
                    // height: "180px",
                    overflow: "hidden",
                    borderRadius: "8px",
                  }}
                >
                  {/* <img
                    src={`${IMG_BASE_URL}/${payment.hostel_tax_image}`}
                    alt="Payment Img"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      display: "block"
                    }}
                  /> */}

                  {renderFile(payment.hostel_tax_image)}
                  
                </div>
                </p>
              </div>
          </div>
        </div>
      </div>


        </div>
        <div className="col-12 col-md-2"></div>
        </div>

    </div>
  );
};

export default PaymentDetails;
